import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import modal from "../util/modal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEdit, faSync, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import { headList } from "../../api/settingApi";

const TicketHeads = () => {

  const user = JSON.parse(sessionStorage.getItem('lgusr'));
  const isSuAdmin = user?.role === 'ADMINISTRATOR';
  const isAdmin = user?.role === 'ADMIN';
  const orgId = user?.orgId;

  const navigate = useNavigate();
  const [pheads, setPheads] = useState([]);

  const fetchData = async () => {
    try {
      const phRes = await headList(orgId);
      setPheads(phRes.data);
    } catch (error) {
      console.error("Error loading data:", error);
    } finally {

    }
  };

  useEffect(() => {
    const handlePageLoad = () => {
      fetchData();
    };
    if (document.readyState === "complete") {
      handlePageLoad();
    } else {
      window.addEventListener("load", handlePageLoad);
    }
    return () => {
      window.removeEventListener("load", handlePageLoad);
    };
  }, []);

  return (
    <div className="p-1">
      <h1 className="text-3xl font-extrabold text-blue-600 mb-6">Settings</h1>
      <div className="space-y-8">
        {/* Ticket Heads */}
        <section>
          {(user.role == "ADMIN" || isSuAdmin) &&
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-semibold text-orange-600">Ticket Heads</h2>
              <button className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600" onClick={() => navigate('/settings/new-phead')}>
                <FontAwesomeIcon icon={faPlus} />
              </button>
            </div>
          }
          <div className="bg-blue-50 shadow-lg rounded-md overflow-hidden">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-blue-100">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase">Name</th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase">Organization</th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase">Has Checklist</th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase">Status</th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase">Updated At</th>
                  <th className="px-6 py-3 text-right text-sm font-medium text-gray-700 uppercase">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {pheads.map((ph) => (
                  <tr key={ph.id}>
                    <td className="px-6 py-4 text-sm text-gray-900">{ph.name}</td>
                    <td className="px-6 py-4 text-sm text-gray-500">{ph.organizationName}</td>
                    <td className="px-6 py-4 text-sm text-gray-500">{ph.hasCheckList ? 'Yes' : 'No'}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">{ph.status}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">{ph.updatedAt}</td>
                    <td className="px-6 py-4 text-right text-sm space-x-2">
                      <button className="text-blue-600 hover:underline"><FontAwesomeIcon icon={faEye} /></button>
                      <button className="text-green-600 hover:underline" onClick={() => navigate(`/settings/modify-head/${ph.id}`)} ><FontAwesomeIcon icon={faEdit} /></button>
                      <button className="text-yellow-600 hover:underline"><FontAwesomeIcon icon={faSync} /></button>
                      <button className="text-red-600 hover:underline"><FontAwesomeIcon icon={faTrash} /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  );
}

export default TicketHeads;

